import {
  RewardStyle,
  Tournament,
} from "@nestcoinco/hyper-api-gateway-api-client";

const MIN_JOINED_GAMERS_FOR_PARTICIPANT_COUNT = 10;
const LOW_SLOT_THRESHOLD_RATIO = 0.25;

type TournamentParticipationFields = Partial<
  Pick<Tournament, "availableSlot" | "participantLimit">
>;

export function getTournamentParticipationSummary(
  tournament?: TournamentParticipationFields
) {
  const participantLimit = tournament?.participantLimit ?? 0;
  const availableSlot = tournament?.availableSlot;
  const joinedCount = Math.max(
    participantLimit - (availableSlot ?? participantLimit),
    0
  );

  const slotsLeft = Math.max(
    availableSlot ?? participantLimit - joinedCount,
    0
  );

  const isAtCapacity = participantLimit > 0 && slotsLeft <= 0;

  return {
    joinedCount,
    slotsLeft,
    isAtCapacity,
    participantLimit,
    hasLowSlots: slotsLeft <= participantLimit * LOW_SLOT_THRESHOLD_RATIO,
    shouldShowJoinedCount:
      joinedCount >= MIN_JOINED_GAMERS_FOR_PARTICIPANT_COUNT,
  };
}

export function shouldShowTournamentRewardRange(rewardStyle?: RewardStyle) {
  return rewardStyle !== RewardStyle.VP;
}
